import React from "react";
import Loader from '../../../../components/Loader';
import Page from '../../../../components/Page';
import HTTPManager from "../../../../utils/httpRequestManager";
// import TableView from '../../../../components/table/tableView';
import { toast, ToastContainer } from 'react-toastify';
import Iconify from '../../../../components/Iconify';
import FormManager from "../../../../components/formComponents/FormManager";
import schema from './schema.json';
import { Box, Grid, Card, Container, Button, Typography, Stack, DialogTitle, Dialog, DialogContent, DialogActions } from '@mui/material';
import FButton from '../../../../components/formComponents/components/button';
import { checkButtonAccess } from "../../../../utils/protector";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const grid = 0;

const getListStyle = isDraggingOver => ({
    //   background: isDraggingOver ? "lightblue" : "lightgrey",
    padding: grid,
    width: '100%'
    //   width: 250
});
export default class ProductService extends React.Component {
    httpManager = new HTTPManager();

    constructor() {
        super();
        this.state = {
            isLoading: false,
            schema: {},
            categories: [],
            selectedCategoryId: '',
            services: [],
            serviceslist: [],
            addForm: false,
            selectedservice: {},
            isImport: false,
            // columns:[
            //     {
            //         field: 'mProductName',
            //         headerName: 'Name',
            //         minWidth: 250,
            //         editable: false,
            //         renderCell: (params) => (
            //             <div style={{position:'relative', height:'100%', paddingLeft:'20px', display:'flex', alignItems:'center', marginLeft:'-10px'}}>
            //                 <div style={{position:'absolute', top:0, left:0,
            //                 width:'5px', bottom:0, background: params.row.mProductColorCode}}>&nbsp;</div>
            //                 {params.row.mProductName}
            //             </div>
            //         )
            //         }, 
            //     {
            //         field: 'mProductType',
            //         headerName: 'Type',
            //         minWidth: 200,
            //         editable: false,
            //         renderCell: (params) => (
            //             <div style={{textTransform:'capitalize'}}>
            //                 {params.row.mProductType}
            //             </div>
            //         )
            //     },
            //     {
            //         field: 'Action',
            //         headerName:'Actions',
            //         flex:1,
            //         minWidth:100,
            //         renderCell: (params) => (
            //             this.getActions(params)                    
            //         ),
            //     }

            // ],
            defaultTaxes: []
        }
        this.handleCloseform = this.handleCloseform.bind(this);
        this.updateRecord = this.updateRecord.bind(this);
        this.setCategory = this.setCategory.bind(this);
        this.setTax = this.setTax.bind(this)
        this.onStateChange = this.onStateChange.bind(this);

        this.getCategories = this.getCategories.bind(this)
        this.onDragEnd = this.onDragEnd.bind(this);
        this.setCategoryForProduct = this.setCategoryForProduct.bind(this)
    }

    getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: grid * 2,
        margin: `0 0 ${grid}px 0`,
        // styles we need to apply on draggables
        ...draggableStyle
    });

    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const services = reorder(
            this.state.services,
            result.source.index,
            result.destination.index
        );
        const oldList = Object.assign([], this.state.services)
        const serviceItems = services.map((c, i) => {
            return {
                mProductId: c.mProductId,
                mCategoryId: this.state.selectedCategoryId,
                sortOrder: i + 1
            }
        })
        this.setState({
            services
        });
        this.setState({ isLoading: true }, () => {
            this.httpManager.postRequest('/merchant/product/reorder', { services: serviceItems }).then(ees => {
                this.setState({
                    isLoading: false,
                    services
                });
            }).catch(e => {
                this.setState({ services: oldList })
            })
        })
    };


    async getProductsByCategory(catid) {
        this.setState({ selectedCategoryId: catid }, async () => {
            await this.httpManager.postRequest('merchant/product/getbyCategory', { categoryId: catid, search: '' }).then(res => {
                this.setState({ services: res.data })
            })
        })
    }

    async getCategories() {
        await this.httpManager.postRequest('merchant/category/getActive', { data: "GET CATEGORY", search: '' }).then(res => {
            this.setState({ categories: res.data }, async () => {
                var schema = Object.assign({}, this.state.schema)
                var properties = schema.properties
                properties.forEach(field => {
                    if (field.name === 'mProductCategories') {
                        field.data = this.state.categories.map(x => ({ label: x.mCategoryName, value: x["id"] }))
                    }
                })
                if (this.state.categories.length > 0) {
                    await this.getProductsByCategory(this.state.categories[0].id)
                }
                else {
                    this.setState({ services: [] })
                }
            })
        })
    }



    onStateChange(values) {
        //console.log("STATE CHANGE CALLED")
        console.log(values)
        var schema = Object.assign({}, this.state.schema);
        var properties = Object.assign([], this.state.schema.properties);
        var props = [];
        var required = Object.assign([], this.state.schema.required)
        properties.forEach((field, i) => {
            // if (field.name === 'mProductCategories' && values[field.name].length > 0 && values[field.name]) {
            //     field.value = values[field.name]
            // }
            if (field.name === 'mProductTaxes' && values["mProductTaxType"] === 'Default') {
                field.type = "hidden"
                field.value = [];
            }
            else if (field.name === 'mProductDefaultTaxes' && values["mProductTaxType"] === 'Custom') {
                field.type = "hidden"
                field.value = [];
            }
            else if (field.name === 'mProductDefaultTaxes' && values["mProductTaxType"] === 'No Tax') {
                field.type = "hidden"
                field.value = [];
            }
            else if (field.name === 'mProductTaxes' && values["mProductTaxType"] === 'No Tax') {
                field.type = "hidden"
                field.value = []
            }
            else if (field.name === 'mProductTaxes' && values["mProductTaxType"] === 'Custom') {
                field.type = "text"
                field.value = values[field.name].map(value => value.mTaxId);
            }
            else if (field.name === 'mProductTaxes' && values["mProductTaxType"] === 'Default') {
                field.type = "text"
                field.value = [];
            }
            else if (field.name === 'mProductDefaultTaxes' && values["mProductTaxType"] === 'Default') {
                field.type = "text"
                field.value = Object.assign([], this.state.defaultTaxes);
            }
            else if (field.name === 'mProductPrice' && values["mProductPriceType"] === 'Variable') {
                field.disabled = true;
                let idx = required.indexOf(field.name);
                field.value = values[field.name];
                required.splice(idx, 1)
            }
            else if (field.name === 'mProductPrice' && values["mProductPriceType"] !== 'Variable') {
                field.disabled = false;
                if (required.indexOf(field.name) === -1)
                    required.push(field.name)
                field.value = values[field.name];
            }
            else {
                field.value = values[field.name];
            }

            props.push(field);
            if (i === properties.length - 1) {
                schema.force = true
                schema.required = required
                schema.properties = props;
                this.setState({ schema: schema }, () => {
                    this.setState({ addForm: true })
                })
            }
        })
    }

    updateRecord(row, status) {
        this.setState({ isLoading: true }, () => {
            this.httpManager.postRequest(`merchant/product/update`, { mProductStatus: status, id: row.id }).then(res => {
                //console.log(res.message);
                this.setState({ isLoading: false });
                this.reloadData(res.message);
            })
        })
    }
    componentDidMount() {
        this.setState({ schema: schema }, () => {
            this.httpManager.getRequest(`merchant/tax/getByType/default`).then(response => {
                var taxids = response.data.map(e => e.mTaxId)
                this.setState({ defaultTaxes: taxids, isLoading: false }, () => {
                    this.getCategories();
                })
            })
        })
    }
    handleCloseform() {
        this.setState({ addForm: false })
    }
    getActions(params) {
        var detail = window.localStorage.getItem('userdetail')
        if (detail !== '' && detail !== undefined && detail !== '{}') {
            var userdetail = JSON.parse(detail);
            return <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>

                {(checkButtonAccess('Inventory') === 'W' || userdetail.userRole === 'Owner') && <FButton
                    variant="outlined"
                    size="small"
                    onClick={() => this.openEdit(params.row)}
                    label="Edit" />}

                {(checkButtonAccess('Inventory') === 'W' || userdetail.userRole === 'Owner') && params.row.mProductStatus === '1' &&
                    <FButton
                        variant="contained"
                        size="small"
                        onClick={() => { this.updateRecord(params.row, 0) }}
                        label="Deactivate" />
                }
                {(checkButtonAccess('Inventory') === 'W' || userdetail.userRole === 'Owner') && params.row.mProductStatus === '0' &&
                    <FButton
                        variant="contained"
                        size="small"
                        onClick={() => { this.updateRecord(params.row, 1) }}
                        label="Activate" />
                }

                {checkButtonAccess('Inventory') !== 'W' && userdetail.userRole !== 'Owner' && <div>N/A</div>}
            </div>
        }
    }
    openEdit(data) {
        // console.log(data)
        var schema = Object.assign({}, this.state.schema);
        var properties = Object.assign([], this.state.schema.properties);
        var props = [];
        var moddata = this.setCategoryForProduct(data)
        properties.forEach((field, i) => {
            field.value = moddata[field.name];
            if (field.name === 'mProductDefaultTaxes') {
                if (moddata['mProductTaxType'] === 'Default')
                    field.value = Object.assign([], this.state.defaultTaxes);
            }
            props.push(field);
            if (i === properties.length - 1) {

                props.push({
                    "component": "TextField",
                    "type": "hidden",
                    "minLength": 1,
                    "maxLength": 50,
                    "grid": 6,
                    "name": "mProductId",
                    "label": "mProductId",
                    "placeholder": "mProductId",
                    "value": moddata.mProductId
                })

                props.push({
                    "component": "TextField",
                    "type": "hidden",
                    "minLength": 1,
                    "maxLength": 50,
                    "grid": 6,
                    "name": "id",
                    "label": "id",
                    "placeholder": "id",
                    "value": moddata.id
                })
                schema.properties = props;
                this.setState({ schema: schema, selectedservice: moddata }, () => {
                    this.onStateChange(moddata)
                    this.setState({ addForm: true })
                })
            }
        })
    }
    reloadData(msg = '') {
        if (msg !== '') {
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton: false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
        this.setState({ isLoading: true, addForm: false }, async () => {
            await this.httpManager.getRequest(`merchant/tax/getByType/default`).then(response => {
                var taxids = response.data.map(e => e.mTaxId)
                this.setState({ defaultTaxes: taxids, isLoading: false })
            })
            await this.getProductsByCategory(this.state.categories[0].id)
            // this.httpManager.getRequest(`merchant/product/get`).then(response=>{ 
            //     //console.log(response.data)
            //     this.setCategory(0, response.data, [])
            // })
        })
    }

    setCategory(idx, products, finalResult) {
        //console.log("CATEGORU")
        if (idx < products.length) {
            var obj = Object.assign({}, products[idx]);
            if (products[idx].mProductCategories.length > 0) {
                obj.mProductCategories = [];
                products[idx].mProductCategories.forEach((o, i) => {
                    obj.mProductCategories.push(o.mCategoryId)
                    if (i === obj.mProductCategories.length - 1) {
                        if (finalResult[idx]) {
                            finalResult[idx] = obj
                        }
                        else {
                            finalResult.push(obj);
                        }
                        this.setCategory(idx + 1, products, finalResult);
                    }
                })
            }
            else {
                //console.log("ELSE COND", idx)
                if (finalResult[idx]) {
                    finalResult[idx] = obj
                }
                else {
                    finalResult.push(obj);
                }
                this.setCategory(idx + 1, products, finalResult);
            }
        }
        else {
            this.setTax(0, products, finalResult)
        }
    }

    setCategoryForProduct(product) {
        product.mProductCategories = product.mProductCategories
            .filter(category => typeof category === 'object' && category.mCategoryId) // Ensure it's an object with mCategoryId
            .map(category => category.mCategoryId);

        return product
    }


    setTax(idx, products, finalResult) {
        //console.log("TAX")
        if (idx < products.length) {
            var obj = Object.assign({}, finalResult[idx]);
            if (products[idx].mProductTaxes.length > 0) {
                obj.mProductTaxes = [];
                products[idx].mProductTaxes.forEach((o, i) => {
                    obj.mProductTaxes.push(o.mTaxId)
                    if (i === obj.mProductTaxes.length - 1) {
                        finalResult[idx] = obj
                        this.setTax(idx + 1, products, finalResult);
                    }
                })
            }
            else {
                finalResult[idx] = obj;
                this.setTax(idx + 1, products, finalResult);
            }
        }
        else {
            this.setState({ services: finalResult, isLoading: false }, () => {
            });
        }
    }

    openAdd() {
        this.setState({ selectedservice: {} }, () => {
            var schemaobj = Object.assign({}, this.state.schema);

            var properties = Object.assign([], this.state.schema.properties);
            var props = [];
            properties.forEach((field, i) => {
                if (field.name === 'mProductTaxType') {
                    field.value = 'Default'
                } else if (field.name === 'mProductType') {
                    field.value = 'Service'
                }
                else if (field.name === 'mProductPriceType') {
                    field.value = 'Fixed'
                }
                else if (field.name === 'mProductDefaultTaxes') {
                    field.type = "text"
                    field.value = Object.assign([], this.state.defaultTaxes);
                }
                else if (field.name === 'mProductTaxes') {
                    field.type = "hidden"
                }
                else {
                    delete field["value"]
                }

                props.push(field);
                if (i === properties.length - 1) {
                    schemaobj.force = true;
                    schemaobj.properties = props;
                    console.log("schema ", schemaobj)
                    this.setState({ schema: schemaobj }, () => {
                        this.setState({ addForm: true })
                    })
                }
            });
        })
    }
    render() {
        return <Page title="Product Service | Astro POS">
            {this.state.isLoading && <Loader show={this.state.isLoading} />}
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={false}
            />
            {!this.state.addForm ?
                <Container maxWidth="xl">
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            Product & Service
                        </Typography>
                        {this.state.isImport && <Dialog
                            open={this.state.isImport}
                            onClose={() => {
                                this.setState({ isImport: false })
                            }}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">
                                Confirmation
                            </DialogTitle>
                            <DialogContent>
                                <p>Importing new products will disable all the existing products and categories, are you sure to import?
                                </p>

                                <form name="importfrm">
                                    <input type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={(e) => {
                                        var validExts = [".xlsx", ".xls"];
                                        var fileExt = e.target.value;
                                        fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
                                        this.setState({ isImport: false })
                                        if (validExts.indexOf(fileExt) < 0) {
                                            alert("Invalid file selected, valid files are of " +
                                                validExts.toString() + " types.");
                                            return false;
                                        }
                                        else {
                                            this.setState({ isLoading: true })
                                            let formData = new FormData()
                                            var det = JSON.parse(window.localStorage.getItem('userdetail'))
                                            formData.append('merchantId', det.merchantId)
                                            formData.append('createdBy', det.id)
                                            formData.append('fileName', det.merchantId + fileExt);
                                            formData.append('files', e.target.files[0])
                                            this.httpManager.postRequestWOEncrypt(`/merchant/product/import`, formData).then(async (r) => {
                                                await this.getCategories()
                                                this.reloadData(r.msg)
                                                document.getElementById('importFile').value = ''
                                            })
                                        }

                                    }} style={{ display: 'none' }} id="importFile" />
                                </form>
                            </DialogContent>
                            <DialogActions>
                                <Button variant='contained' onClick={() => {
                                    //     document.getElementById('importFile').value=''
                                    document.getElementById('importFile').click()
                                }}>
                                    Yes, Import Data
                                </Button>

                                <Button variant='contained' onClick={() => {
                                    document.getElementById('importFile').value = ''
                                    this.setState({ isImport: false })
                                }}>
                                    No
                                </Button>
                            </DialogActions>
                        </Dialog>
                        }
                        {checkButtonAccess('Inventory') === 'W' && <FButton
                            onClick={() => {
                                this.setState({ isImport: true })
                            }}
                            size="large"
                            variant="contained"
                            label="Import Product & Service"
                            startIcon={getIcon('mdi:database-import-outline')}
                        />}
                        {checkButtonAccess('Inventory') === 'W' && <FButton
                            onClick={() => this.openAdd()}
                            size="large"
                            variant="contained"
                            label="Add Product & Service"
                            startIcon={getIcon('mdi:plus')}
                        />}
                    </Stack>

                    <Card>

                        <Grid container className="fullHeight">
                            <Grid item xs={12} style={{ height: 'calc(100% - 45px)', width: '100%', display: 'flex', flexDirection: 'row' }}>
                                <Grid item xs={4} className='sideMenu' style={{ height: '100%', background: '#eaebeb', overflow: 'auto', borderRight: '1px solid #f0f0f0' }}>
                                    <Grid container className="categoryScroller">
                                        {this.state.categories.map(cat => {
                                            return <Grid item xs={12} align="left" style={{ background: cat.mCategoryColorCode + '20', justifyContent: 'flex-start', border: 0, position: 'relative', fontWeight: this.state.selectedCategoryId === cat.id ? '700' : '500', padding: '25px', margin: '0.1rem 0' }} onClick={() => {
                                                this.getProductsByCategory(cat.id)
                                            }}>
                                                {<div style={{ background: cat.mCategoryColorCode !== null && cat.mCategoryColorCode !== undefined && cat.mCategoryColorCode !== '' ? cat.mCategoryColorCode : '#134163', width: '5px', position: 'absolute', 'left': 0, top: 0, bottom: 0 }}>&nbsp;</div>}
                                                {cat.mCategoryName}
                                            </Grid>
                                        })
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item xs={8} style={{ borderLeft: '3px solid #666', background: '#fff', height: '100%', overflow: 'auto' }}>
                                    <Grid container style={{ flexWrap: 'wrap' }}>

                                        <Grid container spacing={3} style={{ height: '40px', background: '#f0f0f0', width: '100%', margin: '0 0', padding: 0 }}>
                                            <Grid item xs={3} style={{ height: '100%', width: '100%', margin: 0, padding: '10px 20px', fontSize: '12px', fontWeight: 'bold' }}>
                                                Product Name
                                            </Grid>
                                            <Grid item xs={2} style={{ height: '100%', width: '100%', margin: 0, padding: 10, fontSize: '12px', fontWeight: 'bold' }}>
                                                Type
                                            </Grid>
                                            <Grid item xs={2} style={{ height: '100%', width: '100%', margin: 0, padding: 10, fontSize: '12px', fontWeight: 'bold' }}>
                                                Status
                                            </Grid>
                                            <Grid item xs={3} style={{ height: '100%', width: '100%', margin: 0, padding: 10, fontSize: '12px', fontWeight: 'bold' }}>

                                            </Grid>
                                        </Grid>


                                        {this.state.services.length > 0 && <DragDropContext onDragEnd={this.onDragEnd}>
                                            <Droppable droppableId="droppable">
                                                {(provided, snapshot) => (
                                                    <div
                                                        {...provided.droppableProps}
                                                        ref={provided.innerRef}
                                                        style={getListStyle(snapshot.isDraggingOver)}
                                                    >
                                                        {this.state.services.map((item, index) => (
                                                            <Draggable key={item.id} draggableId={item.id} index={index}>
                                                                {(provided, snapshot) => (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        style={{
                                                                            ...this.getItemStyle(
                                                                                snapshot.isDragging,
                                                                                provided.draggableProps.style
                                                                            )
                                                                        }}
                                                                    >
                                                                        <Grid container spacing={3} style={{
                                                                            width: '100%', margin: '0', padding: 0,
                                                                            background: (snapshot.isDragging ? "#bee1f7" : "#fff")
                                                                        }}>
                                                                            <Grid item xs={3} style={{ position: 'relative', height: '50px', paddingLeft: '20px', display: 'flex', alignItems: 'center', marginLeft: '-10px', width: '100%', margin: 0, padding: '10px 20px' }}>

                                                                                <div style={{ position: 'absolute', top: 0, left: 0, width: '5px', bottom: 0, background: item.mProductColorCode }}>&nbsp;</div>
                                                                                <div>
                                                                                    {item.mProductName}
                                                                                </div>
                                                                            </Grid>
                                                                            <Grid item xs={2} style={{ height: '100%', width: '100%', margin: 0, padding: 10 }}>
                                                                                {item.mProductType}
                                                                            </Grid>
                                                                            <Grid item xs={2} style={{ height: '100%', width: '100%', margin: 0, padding: 10 }}>
                                                                                {item.mProductStatus === '1' ? 'Active' : 'Inactive'}
                                                                            </Grid>
                                                                            <Grid item xs={3} spacing={3} style={{ height: '100%', width: '100%', margin: 0, padding: 10, fontSize: '12px', fontWeight: 'bold' }}>
                                                                                {this.getActions({ row: item })}
                                                                            </Grid>
                                                                        </Grid>
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </Droppable>
                                        </DragDropContext>}
                                        {this.state.services.length === 0 && <Grid item xs={12} className='servicebox'>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px' }}>
                                                No services found.
                                            </div>
                                        </Grid>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Card>
                </Container> : ''
            }
            {this.state.addForm && <Box sx={{ width: '100%' }}>
                <Grid container spacing={3} alignItems="center" justifyContent="center" style={{ marginLeft: 0, marginRight: 0, width: '100%', fontWeight: 'bold' }} >
                    <Grid item xs={12}>
                        <Stack spacing={3}>
                            <FormManager formProps={this.state.schema} formFunctions={{
                                onStateChange: this.onStateChange
                            }} reloadData={(msg) => this.reloadData(msg)} closeForm={() => this.handleCloseform()} />
                        </Stack>
                    </Grid>
                </Grid>
            </Box>}
        </Page>
    }

}